import { NgModule } from '@angular/core';
import { ConsultaCadinPesquisarComponent } from '../consulta-cadin/consulta-cadin-pesquisar.component';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { CanDeactivateGuardService } from 'src/app/core/can-deactivate-guard.service';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';
import { DominiosResolver } from 'src/app/shared/resolvers/dominios.resolver';
import { EstadoSolicitacaoCancelamentoGarantiaResolver } from 'src/app/shared/resolvers/estados-cancelamento.resolver';
import { LimitesFundoResolver } from 'src/app/shared/resolvers/limites-fundo.resolver';
import { LimitesFundoTranchesPassadasResolver } from 'src/app/shared/resolvers/limites-fundo-tranches-passadas.resolver';
import { DataReferenciaLimiteFundoResolver } from 'src/app/shared/resolvers/data-ref-limite-fundo-cadastro.resolver';
import { TrancheResolver } from 'src/app/shared/resolvers/TrancheResolver';
import { CancelamentoCadastroComponent } from '../cancelamento/cancelamento-cadastro.component';
import { CancelamentoDetalheComponent } from '../cancelamento/cancelamento-detalhe.component';
import { CancelamentoListagemComponent } from '../cancelamento/cancelamento-listagem.component';
import { CancelamentoPesquisaComponent } from '../cancelamento/cancelamento-pesquisa.component';
import { LimiteCadastroComponent } from '../limite/limite-cadastro.component';
import { LimiteFundoCadastroComponent } from '../limite/limite-fundo-cadastro.component';
import { LimitePesquisaComponent } from '../limite/limite-pesquisa.component';
import { AmortizacaoDetalheComponent } from './amortizacao/amortizacao-detalhe/amortizacao-detalhe.component';
import { OperacaoDetalheComponent } from './detalhe/operacao-detalhe.component';
import { LiberacaoDetalheComponent } from './liberacao/liberacao-detalhe.component';
import { ContratacaoLotePesquisaComponent } from './lote-pesquisa/contratacao-lote-pesquisa.component';
import { OperacaoLoteComponent } from './operacao-lote.component';
import { OperacaoPesquisaComponent } from './operacao-pesquisa.component';
import { LimiteDetalheComponent } from '../limite/limite-detalhe.component';
import { LimiteContratacaoPesquisaComponent } from '../limite-contratacao/limite-contratacao-pesquisa.component';
import { LimiteExposicaoPesquisaComponent } from '../limite-exposicao/pesquisa/limite-exposicao-pesquisa.component';
import { OperacaoRepasseBndesCadastroComponent } from '../operacao-repasse-bndes/operacao-repasse-bndes-cadastro/operacao-repasse-bndes-cadastro.component';
import { CalculoEcgComponent } from '../calculo-ecg/calculo-ecg.component';
import { CalculoSaldoDevedorComponent } from '../calculo-saldo-devedor/calculo-saldo-devedor.component';
import {
  ImportacaoLoteIpdComponent
} from "../../../shared/protocolo-ipd/importacao-lote-ipd/importacao-lote-ipd.component";
import {
  ImportacaoPesquisarIpdComponent
} from "../../../shared/protocolo-ipd/importacao-pesquisar-ipd/importacao-pesquisar-ipd.component";

const routes: Routes = [
  {
    path: 'operacoes/pesquisa',
    component: OperacaoPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
      dominios: DominiosResolver
    },
    data: { canReuse: false }
  },
  {
    path: 'cancelamento',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
      estados: EstadoSolicitacaoCancelamentoGarantiaResolver
    },
    data: { canReuse: false },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'pesquisa'
      },
      {
        path: 'pesquisa',
        component: CancelamentoPesquisaComponent,
      },
      {
        path: 'listagem',
        component: CancelamentoListagemComponent,
      },
      {
        path: 'cadastro',
        component: CancelamentoCadastroComponent,
        canDeactivate: [CanDeactivateGuardService],
      },
      {
        path: 'cadastro/:id',
        component: CancelamentoDetalheComponent,
      }
    ]
  },

  {
    path: 'limite-contratacao/pesquisa',
    component: LimiteContratacaoPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver
    },
    data: {
      canReuse: false,
      refreshAgentes: true
    }
  },
  {
    path: 'limite-exposicao/pesquisa',
    component: LimiteExposicaoPesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver
    },
    data: {
      canReuse: false,
      refreshAgentes: true
    }
  },
  {
    path: 'limite/pesquisa',
    component: LimitePesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      limites: LimitesFundoResolver,
      //limitesTranchesPassadas: LimitesFundoTranchesPassadasResolver,
      dataReferenciaLimiteFundo: DataReferenciaLimiteFundoResolver,
      agentes: AgenteFinanceiroResolver,
      tranches: TrancheResolver
    },
    data: {
      canReuse: false,
      refreshAgentes: true
    }
  },
  {
    path: 'limite/cadastro',
    component: LimiteCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    canDeactivate: [CanDeactivateGuardService],
    data: { canReuse: false }
  },
  {
    path: 'limite/cadastro/:id',
    component: LimiteCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    canDeactivate: [CanDeactivateGuardService],
    data: { canReuse: false }
  },
  {
    path: 'limite/detalhe/:id',
    component: LimiteDetalheComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    canDeactivate: [CanDeactivateGuardService],
    data: { canReuse: false }
  },
  {
    path: 'limite-fundo/cadastro',
    component: LimiteFundoCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    canDeactivate: [CanDeactivateGuardService],
    data: { canReuse: false }
  },
  {
    path: 'operacoes/cadastro',
    component: OperacaoDetalheComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      dominios: DominiosResolver
    },
    data: { canReuse: false }
  },
  {
    path: 'operacoes/lote',
    component: ContratacaoLotePesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'operacoes/ipd',
    component: ImportacaoPesquisarIpdComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },

  {
    path: 'consultacadin',
    component: ConsultaCadinPesquisarComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },

  {
    path: 'operacoes/:id',
    component: OperacaoDetalheComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
      dominios: DominiosResolver
    },
    data: { canReuse: false }
  },
  {
    path: 'operacoes/cadastro/lote',
    component: OperacaoLoteComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'operacoes/cadastro/importacao/lote-ipd',
    component: ImportacaoLoteIpdComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'liberacoes/cadastro/:id',
    component: LiberacaoDetalheComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'amortizacoes/cadastro/:id',
    component: AmortizacaoDetalheComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'operacao-repasse/cadastro',
    component: OperacaoRepasseBndesCadastroComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
      agentes: AgenteFinanceiroResolver,
      dominios: DominiosResolver
    },
    data: { canReuse: false }
  },
  {
    path: 'calculo-encargo-concessao-garantia',
    component: CalculoEcgComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'calculo-saldo-devedor',
    component: CalculoSaldoDevedorComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OperacaoRoutingModule { }
